/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type PreviewOrgBotTileCard = typeof PreviewOrgBotTileCard[keyof typeof PreviewOrgBotTileCard];


export const PreviewOrgBotTileCard = {
  cardjoining: 'card.joining',
  cardwaiting_member: 'card.waiting_member',
  cardwaiting_consent: 'card.waiting_consent',
  cardrecording_shortly: 'card.recording_shortly',
  cardrecording: 'card.recording',
  cardpaused: 'card.paused',
  cardstopped: 'card.stopped',
  cardchat_unavailable: 'card.chat_unavailable',
  cardchat_unavailable_recording: 'card.chat_unavailable_recording',
} as const;
